<template>
  <!-- 蛋糕叔叔 订单详情（参考美团外卖订单详情页结构） -->
  <div class='order-detail-page'>
    <div class='pay-status'>
      <img v-if='statusIcon' class='status-icon' :src='statusIcon' alt='' />
      <van-icon v-else name='passed' />
      <span>{{ orderInfo.orderStatusDesc }}</span>
    </div>

    <div class='coupon-info-wrapper'>
      <div class='coupon-info'>
        <img src='@/assets/img/uncle-cake-icon.png' alt='蛋糕叔叔' />
        <div class='info'>
          <span class='title'>蛋糕鲜花</span>
          <span class='subtitle'>{{ orderInfo.goodsName }}</span>
        </div>
      </div>
    </div>

    <div class='info-card'>
      <div class='basic-row'>
        <span class='label'>订单编号</span>
        <span class='value'>{{ orderInfo.orderId }}</span>
      </div>
      <div class='basic-row'>
        <span class='label'>下单时间</span>
        <span class='value'>{{ orderInfo.createTime }}</span>
      </div>
      <div class='basic-row'>
        <span class='label'>付款时间</span>
        <span class='value'>{{ orderInfo.payTime }}</span>
      </div>
      <div class='basic-row'>
        <span class='label'>付款方式</span>
        <span class='value'>{{ orderInfo.payMethodDesc || orderInfo.payMethod }}</span>
      </div>
    </div>

    <div class='info-card amount-card'>
      <div class='amount-row'>
        <span class='label'>订单金额</span>
        <span class='value'>¥ {{ orderInfo.saleAmount }}</span>
      </div>
      <div class='amount-row'>
        <span class='label'>优惠金额</span>
        <span class='value red'>- ¥ {{ orderInfo.discountAmount }}</span>
      </div>
      <div v-if='orderInfo.hasRefund' class='amount-row'>
        <span class='label'>退款时间</span>
        <span class='value'>{{ orderInfo.refundTime }}</span>
      </div>
      <div v-if='orderInfo.hasRefund' class='amount-row'>
        <span class='label'>退款金额</span>
        <span class='value'>¥ {{ orderInfo.refundAmount }}</span>
      </div>
      <div class='amount-row actual-payment'>
        <span class='label'></span>
        <span class='value'>实付款：<span class='red'>¥ {{ orderInfo.payAmount }}</span></span>
      </div>
      <div class='detail-action'>
        <van-button plain type='info' color='#CECECE' @click='viewOrderList'>查看订单</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { getUncleCakeOrderDetail, getUncleCakeOrderListUrl } from '@/api/uncleCake'

export default {
  name: 'UncleCakeOrderDetail',
  data() {
    return {
      orderId: '',
      orderInfo: {},
      statusIcon: '' // 状态图标
    }
  },
  mounted() {
    // 兼容 orderID / orderId 两种参数写法
    this.orderId = this.$route.query.orderID || this.$route.query.orderId || ''
    if (this.orderId) {
      this.getDetail()
    }
  },
  methods: {
    // 查看订单
    viewOrderList() {
      getUncleCakeOrderListUrl()
        .then(res => {
          if (!res || !res.data) {
            Toast('获取链接失败,请稍后重试')
            return
          }
          window.location.href = res.data
        })
        .catch(err => {
          Toast(err.msg || err.message || '获取链接失败')
        })
    },
    // 获取订单详情
    getDetail() {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      getUncleCakeOrderDetail({
        orderId: this.orderId
      })
        .then((res) => {
          this.$toast.clear()
          if (!res) return
          if (res.code === 200 && res.data) {
            this.orderInfo = res.data
            this.setStatusIcon()
          }
        })
        .catch((err) => {
          this.$toast.clear()
          Toast(err.msg || err.message || '获取订单详情失败')
        })
    },
    // 设置状态图标
    setStatusIcon() {
      const iconMap = {
        '1': require('@/assets/img/status/ic-unpaid.png'), // 待支付
        '2': require('@/assets/img/status/ic-going.png'), // 进行中
        '3': require('@/assets/img/status/ic-finished.png'), // 已完成
        '4': require('@/assets/img/status/ic-canceled.png'), // 已取消
        '30': require('@/assets/img/status/ic-refunded.png') // 退款完成
      }
      this.statusIcon = iconMap[this.orderInfo.orderStatus] || ''
    }
  }
}
</script>

<style lang='scss' scoped>
.order-detail-page {
  width: 100%;
  min-height: 100%;
  padding: 0.1rem;
  box-sizing: border-box;
  text-align: left;

  .pay-status {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 0.135rem;

    .status-icon {
      width: 0.17rem;
      height: 0.17rem;
    }

    .van-icon {
      font-size: 0.17rem;
      color: #0d0d0d;
    }

    span {
      margin-left: 0.07rem;
      color: #0d0d0d;
      font-size: 0.17rem;
      font-weight: 600;
      line-height: 0.17rem;
    }
  }

  .coupon-info-wrapper,
  .info-card {
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    border-radius: 0.06rem;
    box-shadow: 0 0.01rem 0.02rem 0 rgba(192, 192, 192, 0.08);
  }

  .coupon-info-wrapper {
    margin-top: 0.16rem;
    padding: 0.12rem;
  }

  .coupon-info {
    display: flex;

    img {
      flex: 0 0 0.675rem;
      width: 0.675rem;
      height: 0.675rem;
      border-radius: 0.04rem;
    }

    .info {
      display: flex;
      flex: 1;
      min-width: 0;
      height: 0.6rem;
      margin-left: 0.12rem;
      flex-direction: column;
      justify-content: space-around;
      align-self: center;
    }

    .title,
    .subtitle,
    .tips {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .title {
      color: #0d0d0d;
      font-size: 0.14rem;
      font-weight: 600;
      line-height: 0.2rem;
    }

    .subtitle {
      color: #0d0d0d;
      font-size: 0.14rem;
      font-weight: 500;
      line-height: 0.2rem;
    }

    .tips {
      color: #999;
      font-size: 0.11rem;
      line-height: 0.15rem;
    }
  }

  .info-card {
    margin-top: 0.1rem;
    padding: 0.1rem 0.12rem;
  }

  .basic-row,
  .amount-row {
    display: flex;
    align-items: center;
    font-size: 0.14rem;

    .label {
      color: #666;
      font-weight: 400;
    }

    .value {
      min-width: 0;
      color: #0d0d0d;
      font-weight: 600;
      overflow-wrap: anywhere;
    }
  }

  .basic-row {
    min-height: 0.43rem;

    .label {
      flex: 0 0 23%;
    }

    .value {
      flex: 1;
    }
  }

  .amount-card {
    margin-top: 0.1rem;
  }

  .amount-row {
    min-height: 0.46rem;
    justify-content: space-between;

    .red {
      color: #ff0d37;
    }
  }

  .detail-action {
    display: flex;
    justify-content: flex-end;

    .van-button {
      min-width: 0.8rem;
      height: 0.32rem;
      padding: 0 0.1rem;
      border: 0.01rem solid #cecece;
      border-radius: 0.04rem;
      margin-top: 0.1rem;

      ::v-deep .van-button__text {
        color: #0d0d0d;
        font-size: 0.13rem;
        font-family: PingFang SC/PingFang SC-Regular;
        font-weight: 500;
      }
    }
  }
}
</style>
